import React from "react"
import styled from "styled-components"

const Text =  ({ children, ...other }) => <StyledText {...other}>{children}</StyledText>

const StyledText = styled.p``

export default Text